// extracted by mini-css-extract-plugin
export default {"cls1":"VeloActionBar-StyledMenuSubheader_cls1__f-Qo4","cls2":"VeloActionBar-StyledMenuSubheader_cls2__YJ0KH VeloActionBar-StyledMenuSubheader_cls1__f-Qo4"};